import styled from 'styled-components';

import { Card } from '@xingternal/card';
import { mediaConfined } from '@xingternal/layout-tokens';
import { space3XL, space4XL, space5XL, spaceL, spaceM, spaceS, spaceXL, spaceXXL } from '@xingternal/tokens';
import { Headline } from '@xingternal/typography';

export const Container = styled.div`
  margin-bottom: ${space4XL};

  @media ${mediaConfined} {
    margin-bottom: ${space5XL};
  }
`;

export const Title = styled(Headline)`
  margin-bottom: ${spaceL};

  @media ${mediaConfined} {
    margin-bottom: ${spaceXL};
  }
`;

export const StyledCard = styled(Card)`
  padding: ${spaceXL};

  @media ${mediaConfined} {
    padding: ${spaceXXL};
  }
`;

export const CitiesQAWrapper = styled.div<{ $hasMargin: boolean }>`
  margin-bottom: ${(props) => (props.$hasMargin ? `${space3XL}` : 0)};
`;

export const Question = styled(Headline)`
  margin-bottom: ${spaceS};

  @media ${mediaConfined} {
    margin-bottom: ${spaceM};
  }
`;
